define([
	"dojo/_base/declare",
	"csi/utility/stringUtility",
	"Apparel/StructureItemTable"
], function(declare, {stringSubstitute}, StructureItemTable) {

	return declare(StructureItemTable, {
		BPRelations: {
			"ParentSeason": "BPSeason",
			"Category1": "BPCategory1",
			"Category2": "BPCategory2",
			"Collection": "BPCollection"
		},

		_resolveViewPath: function(/*csi.view.Widget*/view, /*Relationship?*/r) {
			// summary: substitute correct relationship in path to access StructureItem
			var id = this._resolveViewRelation(view);
			var apaths = view.relRoot.m_addPaths;
			apaths[0].m_path = stringSubstitute(apaths[0].m_path, [id]);
			apaths[1].m_path = stringSubstitute(apaths[1].m_path, [this.BPRelations[id]]);
		}
	});
});